import React from 'react';
import styles from './MoonshotBackground.less';

export const MoonshotBackground = () => (
  <div className={styles.background}>
    <img
      alt=""
      className={styles.left}
      src={require('resources/images/moonshot/background-left.svg')}
    />
    <img
      alt=""
      className={styles.right}
      src={require('resources/images/moonshot/background-right.svg')}
    />
  </div>
);
